import { useState } from "react";
import { getInitialDataEvents } from "../controllers/events";
import { Events, Query, Result } from "../interfaces";
import { Adapter } from "../shared/adapter";
import { useSelector } from "react-redux";
import { EventsAdapter } from "../adapter/events-adapter";

const initialState: Result<Events> = {
  loading: false,
  values: [],
};

export default function useEventsSearch() {
  const [result, setResult] = useState<Result<Events>>(initialState);
  const userState = useSelector((state: any) => state.user.user);

  const searchEvents = async (
    collection: string,
    query: Query,
    page?: number,
    limit?: number
  ) => {
    try {
      setResult((prevResult) => ({ ...prevResult, loading: true }));
      const response = await getInitialDataEvents(
        collection || "all",
        query,
        page,
        limit,
        userState?.me
      );

      try {
        Adapter.from(response.items).to((value) =>
          new EventsAdapter(value).adapt()
        );
      } catch (error) {
        console.log("error en el adaptador EventsAdapter", error);
      }
      setResult({
        values: Adapter.from(response.items).to((value) =>
          new EventsAdapter(value).adapt()
        ),
        loading: false,
        pagination: {
          limit,
          page,
          total: response.meta.total,
        },
      });
    } catch (error) {
      console.log("error", error);
      setResult((prevResult) => ({ ...prevResult, loading: false }));
    }
  };

  return {
    result,
    searchEvents,
  };
}
